import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { forkJoin, noop, Observable, switchMap, tap } from 'rxjs';
import { Store } from '@ngxs/store';
import { SavedView } from '@core/models';
import { JupiterState } from '../@store/state';
import { TsComponent } from '../@components/ts.component';
import { RelatedToActions, ViewActions } from '@jupiter-actions';
import { JupiterDashboardLoadingComponent } from './dashboard-loading/dashboard-loading.component';

@Component({
  selector: 'jupiter-splash',
  standalone: true,
  imports: [JupiterDashboardLoadingComponent],
  templateUrl: './splash.component.html',
  styleUrl: './splash.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JupiterSplashComponent extends TsComponent implements OnInit {
  views$: Observable<SavedView[]> = inject(Store).select(JupiterState.getViews);

  ngOnInit(): void {
    this.activatedRoute.params
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        switchMap((params: { relatedToKey: string }) => {
          if (params.relatedToKey === 'void') {
            if (this.activatedRoute.snapshot.queryParams.return?.includes('moon')) {
              const [prefix, contextRelatedToKey, contextViewId, contextRecordId, moon, relatedToKey, viewId] =
                this.activatedRoute.snapshot.queryParams.return.split('/').filter((x) => x);

              this.store.dispatch(
                new RelatedToActions.Set(relatedToKey, {
                  relatedToKey: contextRelatedToKey,
                  relatedToId: contextRecordId,
                }),
              );

              return this.store.dispatch(new ViewActions.SetViews()).pipe(
                tap(() => {
                  this.router.navigateByUrl(this.activatedRoute.snapshot.queryParams.return);
                  this.store.dispatch(
                    new RelatedToActions.SetBackUrl(this.activatedRoute.snapshot.queryParams.backUrl),
                  );
                }),
              );
            }

            const [prefix, relatedToKey, viewId, recordId, tab] = this.activatedRoute.snapshot.queryParams.return
              .split('/')
              .filter((x) => x);

            return forkJoin([
              this.store.dispatch(new RelatedToActions.Set(relatedToKey)),
              this.store.dispatch(new ViewActions.SetViews()),
            ]).pipe(
              tap(() => {
                this.router.navigateByUrl(this.activatedRoute.snapshot.queryParams.return);
                this.store.dispatch(new RelatedToActions.SetBackUrl(this.activatedRoute.snapshot.queryParams.backUrl));
              }),
            );
          } else {
            return forkJoin([
              this.store.dispatch(new RelatedToActions.Set(params.relatedToKey)),
              this.store.dispatch(new ViewActions.SetViews()),
            ]).pipe(
              tap(() => {
                const views = this.store.selectSnapshot(JupiterState.getViews);
                if (views.length > 0) {
                  const [firstView] = views;
                  this.store.dispatch(new ViewActions.SetView(firstView.id));
                  this.router.navigateByUrl(`${this.router.url}/${firstView.id}`);
                }
              }),
            );
          }
        }),
      )
      .subscribe(noop);
  }
}
